/**
 * @event onReady 初始化完成
 * @event onAfterSend 发送完成
 * */
const events = ['onReady', 'onAfterSend'];
const eventHandler = {};

export function init(config = {}) {
  events.forEach((e) => {
    eventHandler[e] = config[e] || null;
  });
}

export function trigger(event) {
  const args = Array.prototype.slice.call(arguments, 1);
  typeof eventHandler[event] === 'function' && eventHandler[event].apply(null, args);
}
